import { SVG } from './SVG';
const IconSymptomCheckerVector = ({ fill = '#fff', background = '#835692' }) => (
  <SVG width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M35.9926 26.408C39.8604 20.2102 39.1166 11.9132 33.7611 6.51511C27.5627 0.267344 17.4965 0.267344 11.2484 6.51511C5.05 12.7629 5.05 22.9592 11.2484 29.207C16.6039 34.655 24.8354 35.3548 30.9842 31.4562L36.8356 32.3059L35.9926 26.408Z"
      stroke={fill}
      strokeWidth="1.75"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6632 24.1713C13.0704 20.5498 7.24558 20.5498 3.70715 24.1713C0.604218 27.2989 0.168719 32.0727 2.40065 35.6393L1.91072 39.0412L5.28583 38.5474C8.82426 40.7971 13.5603 40.3581 16.6632 37.2854C20.2561 33.6639 20.2561 27.7928 16.6632 24.1713Z"
      fill={background}
      stroke={fill}
      strokeWidth="1.75"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9954 31.6884C14.5365 31.6884 14.9752 31.2462 14.9752 30.7007C14.9752 30.1553 14.5365 29.7131 13.9954 29.7131C13.4542 29.7131 13.0155 30.1553 13.0155 30.7007C13.0155 31.2462 13.4542 31.6884 13.9954 31.6884Z"
      stroke={fill}
      strokeWidth="1.75"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.3744 31.6884C6.91557 31.6884 7.35428 31.2462 7.35428 30.7007C7.35428 30.1553 6.91557 29.7131 6.3744 29.7131C5.83323 29.7131 5.39453 30.1553 5.39453 30.7007C5.39453 31.2462 5.83323 31.6884 6.3744 31.6884Z"
      stroke={fill}
      strokeWidth="1.75"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.1839 31.6884C10.725 31.6884 11.1637 31.2462 11.1637 30.7007C11.1637 30.1553 10.725 29.7131 10.1839 29.7131C9.64268 29.7131 9.20398 30.1553 9.20398 30.7007C9.20398 31.2462 9.64268 31.6884 10.1839 31.6884Z"
      stroke={fill}
      strokeWidth="1.75"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.3067 15.2121H25.1331V12.0132C25.1331 11.6634 24.8356 11.3635 24.4885 11.3635H20.5215C20.1744 11.3635 19.8768 11.6634 19.8768 12.0132V15.2121H16.7032C16.3561 15.2121 16.0586 15.512 16.0586 15.8619V19.8604C16.0586 20.2103 16.3561 20.5102 16.7032 20.5102H19.8768V23.709C19.8768 24.0589 20.1744 24.3588 20.5215 24.3588H24.4885C24.8356 24.3588 25.1331 24.0589 25.1331 23.709V20.5102H28.3067C28.6538 20.5102 28.9513 20.2103 28.9513 19.8604V15.8619C28.9513 15.512 28.6538 15.2121 28.3067 15.2121Z"
      stroke={fill}
      strokeWidth="1.75"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SVG>
);

export { IconSymptomCheckerVector as default, IconSymptomCheckerVector };
